<template>
  <BaseModal cardWidth="452px" noPadding noToolbar noExit @close="$emit('close')">
    <template #default>
      <!-- Modal Header -->
      <div class="relative w-full flex items-start gap-2 p-5 border-b border-border-normal">
        <RefreshIcon class="text-icon-muted flex-shrink-0" />
        <div class="flex-grow flex flex-col gap-1">
          <BaseText type="label" size="sm" class="text-text-muted">
            Refresh API Key
          </BaseText>
          <BaseText type="body" size="sm" class="text-text-normal">
            This will permanently invalidate your current key
          </BaseText>
        </div>
        <!-- Close button -->
        <button class="absolute top-3 right-3 p-1 transition-opacity" @click="$emit('close')">
          <TagRemoveIcon stroke="#5E6678" :width="16" :height="16" />
        </button>
      </div>
      <!-- Information Body -->
      <div class="w-full flex flex-col gap-5 p-5 border-b border-border-normal">
        <!-- Main Text -->
        <div class="w-full flex flex-col gap-2.5">
          <BaseText type="label" size="sm" class="text-text-loud">
            What happens when you refresh your key?
          </BaseText>
          <BaseText type="body" size="sm" class="text-text-normal pl-3.5">
            <ul>
              <li>Your existing API key will be <span class="text-secondary-red-200">immediately revoked</span> and cannot be recovered.</li>
              <li>Any integrations, services, or apps using the current key will stop working instantly.</li>
              <li>A new key will be generated which you may copy after this modal is closed.</li>
            </ul>
          </BaseText>
        </div>
        <!-- divider -->
        <div class="w-full h-0 border-t border-border-normal" />
        <!-- Final Disclaimer Text -->
        <BaseText type="body" size="sm" class="text-secondary-red-300 bg-secondary-red-10 px-2.5 py-2 rounded-lg">
          Make sure you're ready to update your key in all environments before proceeding. Downtime may occur if services are not updated promptly.
        </BaseText>
      </div>
      <!-- Modal Actions Footer -->
      <div class="w-full flex flex-col gap-4 p-5">
        <button class="px-2 py-1.5 rounded-md transition duration-100 hover:bg-neutral-25"
        @click="$emit('close')">
          <BaseText type="label" size="sm" class="text-text-muted">
            Cancel
          </BaseText>
        </button>
        <button class="submit-btn enabled w-full py-1.5 px-3 rounded-md"
        @click="handleRefreshKey">
          <BaseText type="label" size="sm">
            Yes, Refresh Key
          </BaseText>
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import RefreshIcon from '../globals/Icons/LensIcons/RefreshIcon.vue'
import TagRemoveIcon from '../globals/Icons/TagRemoveIcon.vue'

export default {
  name: 'RefreshApiKeyModal',
  components: {
    RefreshIcon,
    TagRemoveIcon
  },
  methods: {
    handleRefreshKey () {
      this.$emit('refresh-key')
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
@property --submit-btn-opacity-1 {
  syntax: '<number>';
  initial-value: 0.12;
  inherits: false;
}
@property --submit-btn-opacity-2 {
  syntax: '<number>';
  initial-value: 0.12;
  inherits: false;
}
.submit-btn {
  background: linear-gradient(180deg, rgba(255, 255, 255, var(--submit-btn-opacity-1)) 0%, rgba(255, 255, 255, var(--submit-btn-opacity-2)) 100%), #F4003A;
  color: white;
  box-shadow: 0px -1px 12px 0px rgba(255, 255, 255, 0.12) inset, 0px 0px 0px 1px #C80031;
  transition: box-shadow 100ms ease-in-out,
    color 100ms ease-in-out, 
    background-color 100ms ease-in-out,
    --submit-btn-opacity-1 100ms ease-in-out, 
    --submit-btn-opacity-2 100ms ease-in-out,
    --del-submit-color 100ms ease-in-out;
}
.submit-btn.enabled:hover {
  --submit-btn-opacity-1: 0.24;
  --submit-btn-opacity-2: 0;
}
</style>